import angular from 'angular';
import userStorage from '@/shared/services/userStorage';

const storageKey = 'sidebarCollapsed';
angular.module('cloudX').controller('CollapsableSidebarCtrl', [
  '$timeout',
  function($timeout) {
    const sb = this;
    /*Disable animations on pageload*/
    sb.loading = true;
    sb.collapsed = userStorage.getItem(storageKey) || false;

    sb.setCollapsed = function(collapsed) {
      sb.collapsed = !!collapsed;
      userStorage.setItem(storageKey, sb.collapsed);
    };

    sb.toggleSidebar = function() {
      sb.setCollapsed(!sb.collapsed);
    };

    sb.showSidebar = function() {
      sb.setCollapsed(false);
    };
    sb.hideSidebar = function() {
      sb.setCollapsed(true);
    };

    $timeout(function() {
      sb.loading = false;
    }, 500);
  },
]);
